import { ChangeDetectorRef, Component, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { IProject } from '../../../components/petl/petl-types';
import { PetlService } from '../../../services/petl.service';
import { PetlBaseComponent } from '../petl-base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-petl-manage-projects-ng',
    styleUrls: ['../../sharedStyles/base.scss', '../petl-base.scss', './manage-projects.component.scss'],
    templateUrl: './manage-projects.component.html'
})

export class PetlManageProjectsComponent extends PetlBaseComponent {

    projects: IProject[];
    order?: string;
    reverse: boolean = false;

    constructor(_vcr: ViewContainerRef, protected readonly petlService: PetlService, protected readonly cdr: ChangeDetectorRef) {
        super(_vcr, petlService, cdr);
        this.refreshProjects();
    }

    async refreshProjects() {
        this.loading = true;
        this.projects = null;
        this.projects = await this.petlService.getProjectList();
        this.loading = false;
    }

    async renew(project) {
        this.loading = true;
        await this.petlService.renewProject(project);
        await this.refreshProjects();
    }

    async delete(project) {
        this.loading = true;
        await this.petlService.deleteProject(project);
        await this.refreshProjects();
    }

    view(project) {
        project.mapped = true;
        this.petlService.project = project;
        this.petlService.addProjectToMap(project);
    }

    setOrder(field) {
        if (this.order === field && !this.reverse) {
            this.reverse = true;
        } else {
            this.reverse = null;
        }
        this.order = field;
        this.sort(this.order, this.reverse);
    }

    sort(fieldName: string, decending: boolean = false) {
        const negate = decending ? -1 : 1;
        if (this.projects.length > 1) {
            this.projects = this.projects.sort((a, b) => {
                const type = typeof a[fieldName];
                if (type === 'string') {
                    return (a[fieldName]).localeCompare(b[fieldName]) * negate;
                } else if (type === 'number') {
                    return (a[fieldName] - b[fieldName]) * negate;
                }
            });
        }
    }
}
